// src/pages/tournamentDetails/helpers.js

export function formatTimeFromDate(dateObj) {
  return dateObj.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
}

export function msToMMSS(ms) {
  const total = Math.max(Math.floor(ms / 1000), 0);
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${String(s).padStart(2, "0")}`;
}

export function shuffleArray(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

export function seatRoleLabel(seatNumber) {
  if (seatNumber === 1) return "Seat 1 — Button";
  if (seatNumber === 2) return "Seat 2 — Small Blind";
  if (seatNumber === 3) return "Seat 3 — Big Blind";
  return `Seat ${seatNumber}`;
}

export function formatMoney(n) {
  const num = Number(n || 0);
  return num.toLocaleString(undefined, { style: "currency", currency: "USD" });
}

export function placeSuffix(n) {
  const v = Number(n);
  if (v % 100 >= 11 && v % 100 <= 13) return "th";
  if (v % 10 === 1) return "st";
  if (v % 10 === 2) return "nd";
  if (v % 10 === 3) return "rd";
  return "th";
}

/* ===== Payout rounding ===== */
export function roundToIncrement(amount, increment = 5, mode = "nearest") {
  const inc = Number(increment) || 1;
  if (inc <= 0) return amount;

  const x = amount / inc;
  if (mode === "down") return Math.floor(x) * inc;
  if (mode === "up") return Math.ceil(x) * inc;
  return Math.round(x) * inc;
}

/**
 * Returns payout rows with rounded amounts that still sum to prizePool.
 * Strategy:
 * 1) compute raw amounts from percent
 * 2) round each to increment
 * 3) fix the remainder by adjusting the chosen place (default: last place)
 */
export function computeRoundedPayouts(prizePool, payouts, opts = {}) {
  const { increment = 5, rounding = "nearest", adjustPlace = "last" } = opts;

  const pool = Number(prizePool || 0);
  const rows = (Array.isArray(payouts) ? payouts : [])
    .slice()
    .sort((a, b) => Number(a.place) - Number(b.place))
    .map((p) => {
      const pct = Number(p.percent || 0);
      const raw = (pool * pct) / 100;
      const rounded = roundToIncrement(raw, increment, rounding);
      return { ...p, pct, raw, amount: rounded };
    });

  const sum = rows.reduce((s, r) => s + Number(r.amount || 0), 0);
  const delta = Math.round((pool - sum) * 100) / 100;
  if (!rows.length || Math.abs(delta) < 0.001) return rows;

  let idx = rows.length - 1;
  if (adjustPlace !== "last") {
    const i = rows.findIndex((r) => Number(r.place) === Number(adjustPlace));
    if (i !== -1) idx = i;
  }

  rows[idx] = {
    ...rows[idx],
    amount: Math.round((Number(rows[idx].amount || 0) + delta) * 100) / 100,
  };

  return rows;
}